/* AUTO-GENERATED. DO NOT EDIT. */
export const BUILD_INFO = {
  version: "0.1.0",
  tag: "0.1.0",
  packageVersion: "",
  describe: "v0.1.0-2-g70a1302-dirty",
  commit: "70a1302",
  branch: "main",
  buildTime: "2026-01-28T13:06:09.551Z",
} as const;
